/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminPriceChange
 */
export interface AdminPriceChange {
    /**
     * 
     * @type {string}
     * @memberof AdminPriceChange
     */
    changedAt: string;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceChange
     */
    listingId: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceChange
     */
    newPrice: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceChange
     */
    oldPrice?: number;
}

export function AdminPriceChangeFromJSON(json: any): AdminPriceChange {
    return AdminPriceChangeFromJSONTyped(json, false);
}

export function AdminPriceChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPriceChange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'changedAt': json['changedAt'],
        'listingId': json['listingId'],
        'newPrice': json['newPrice'],
        'oldPrice': !exists(json, 'oldPrice') ? undefined : json['oldPrice'],
    };
}

export function AdminPriceChangeToJSON(value?: AdminPriceChange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'changedAt': value.changedAt,
        'listingId': value.listingId,
        'newPrice': value.newPrice,
        'oldPrice': value.oldPrice,
    };
}

